import createIcon from '../../createIcon';

/**
 * @component @name Bedtime
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMDA5OSAyLjAxNDFDNy4yNTk5MiAxLjgxNDEgMi42Njk5MiA2LjQxNDEgMi42Njk5MiAxMS45OTQxQzIuNjY5OTIgMTcuNTE0MSA3LjE0OTkyIDIxLjk5NDEgMTIuNjY5OSAyMS45OTQxQzE2LjM3OTkgMjEuOTk0MSAxOS41OTk5IDE5Ljk3NDEgMjEuMzI5OSAxNi45NzQxQzEzLjgxOTkgMTYuNzI0MSA5LjIzOTkyIDguNTQ0MSAxMy4wMDk5IDIuMDE0MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bedtime = createIcon('Bedtime', [
  [
    'path',
    {
      d: 'M13.0099 2.0141C7.25992 1.8141 2.66992 6.4141 2.66992 11.9941C2.66992 17.5141 7.14992 21.9941 12.6699 21.9941C16.3799 21.9941 19.5999 19.9741 21.3299 16.9741C13.8199 16.7241 9.23992 8.5441 13.0099 2.0141Z',
      key: 'oxnkrx',
    },
  ],
]);

export default Bedtime;
